














































import { Vue, Component, Prop, p, Mixin } from "av-ts";
import responsiveMixin from "../../responsiveMixin";

@Component
export default class PageLoader extends mixin(responsiveMixin, Vue) {
    @Prop condition = p<boolean>({
        required: true
    });

    mobileMode: boolean = false;

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/PageLoader.vue